<template>
    <div>
        <el-card shadow="hover">
            <el-button @click="handleEditOrCreate">添加权限</el-button>
        </el-card>
        <br />
        <el-card shadow="hover">
            <el-table
                v-loading="loading"
                :data="listTree"
                row-key="id"
                :tree-props="listProps"
                :default-expand-all="true"
            >
                <el-table-column prop="title" label="名称"></el-table-column>
                <el-table-column prop="name" label="页面地址"></el-table-column>
                <el-table-column label="操作" min-width="160">
                    <template slot-scope="scope">
                        <el-button
                            size="mini"
                            @click="handleEditOrCreate(scope.$index, scope.row)"
                        >
                            编辑
                        </el-button>
                        <el-button
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.$index, scope.row)"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 添加信息弹出层 -->
        <el-dialog :visible.sync="addInfoVisible" :title="addInfoTitle">
            <el-form :model="addInfoForm" label-width="80px">
                <el-form-item label="权限标题">
                    <el-input v-model="addInfoForm.title" />
                </el-form-item>
                <el-form-item label="权限链接">
                    <el-input v-model="addInfoForm.link" />
                </el-form-item>
                <el-form-item label="父级权限">
                    <el-cascader
                        :key="cascaderKey"
                        v-model="addInfoForm.parent"
                        :options="cascaderTree"
                        :props="{
                            value: 'id',
                            label: 'title',
                            checkStrictly: true
                        }"
                        filterable
                        clearable
                        style="width: 100%"
                        placeholder="不选择即为根节点"
                    ></el-cascader>
                </el-form-item>
                <el-form-item style="text-align: right">
                    <el-button
                        type="primary"
                        @click="handleUpload()"
                        style="width: 120px"
                    >
                        提交
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import {
    apiGetAuthList,
    updateAuthInfo,
    deleteAuth
} from "@/api/views/manager/permissions";

export default {
    name: "ManagerPermissions",
    data() {
        return {
            /// 列表
            // 权限列表
            list: [],
            // 权限列表树
            listTree: [],
            // 加载状态
            loading: true,
            // 列表子节点配置
            listProps: {
                children: "children"
            },

            /// 弹出层
            // 添加权限弹出层
            addInfoVisible: false,
            // 弹出层标题
            addInfoTitle: "",
            // 添加权限表单
            addInfoForm: {
                id: 0,
                title: "",
                link: "",
                parent: []
            },

            /// 级联选择器
            // 级联选择器key值
            cascaderKey: 0,
            // 级联选择器使用的树
            cascaderTree: []
        };
    },
    created() {
        // 获取权限列表
        this.getPermissionsList();
    },
    methods: {
        // 获取权限列表
        getPermissionsList() {
            // 开始加载
            this.loading = true;
            // 重置一下列表树
            this.listTree = [];
            // 列表转树
            apiGetAuthList().then(res => {
                let obj = {};
                const list = res.categorylist;
                // 缓存一下一维数组
                this.list = list;

                list.map(element => {
                    obj[element.id] = element;
                });
                list.forEach(item => {
                    const id = item.auth_pid;
                    if (id == 0) {
                        this.listTree.push(item);
                    } else {
                        if (obj[id].children) {
                            obj[id].children.push(item);
                        } else {
                            obj[id].children = [item];
                        }
                    }
                });

                // 加载结束
                this.loading = false;
            });
        },
        // 点击添加修改权限，显示弹出层
        handleEditOrCreate(index, row) {
            // 重置级联选择器
            ++this.cascaderKey;
            // 把当前的树缓存到当前控件下，多维数组深拷贝
            this.cascaderTree = JSON.parse(JSON.stringify(this.listTree));

            if (row) {
                // 编辑

                /// 遍历一维权限数组list找到当前节点的路径
                // 查出当前节点路径
                let temp = row;
                let path = [temp.id];
                for (; temp.auth_pid != 0; ) {
                    this.list.forEach(item => {
                        if (temp.auth_pid === item.id) {
                            path.unshift(item.id);
                            temp = item;
                        }
                    });
                }

                /// 禁用当前节点，不可更改为当前节点
                // 缓存设置为树
                temp = this.cascaderTree;
                // 遍历路径
                path.forEach((pathItem, pathIndex) => {
                    temp.forEach(item => {
                        // 找到节点
                        if (pathItem === item.id) {
                            // 如果是最后一个节点
                            if (pathIndex === path.length - 1) {
                                // 禁用节点
                                item.disabled = true;
                            } else {
                                // 增加树层级
                                temp = item.children;
                            }
                        }
                    });
                });

                this.addInfoForm.id = row.id;
                // path是上面搜索出来的路径
                this.addInfoForm.parent = path;
                this.addInfoForm.title = row.title;
                this.addInfoForm.link = row.name;
                this.addInfoTitle = "修改权限";
            } else {
                this.resertInfoForm();
                // 添加
                this.addInfoTitle = "添加权限";
            }
            // 显示添加权限弹出层
            this.addInfoVisible = true;
        },
        // 提交添加修改权限
        handleUpload() {
            // 获取父元素节点id
            let parent = this.addInfoForm.parent;
            if (parent.length == 0) {
                parent = 0;
            } else {
                parent = parent[parent.length - 1];
            }

            updateAuthInfo({
                authname: this.addInfoForm.link,
                authid: this.addInfoForm.id,
                auth_pid: parent,
                authtitle: this.addInfoForm.title
            }).then(() => {
                // 获取权限列表
                this.getPermissionsList();
                // 隐藏添加权限弹出层
                this.addInfoVisible = false;
            });
        },
        // 点击删除权限
        handleDelete(index, row) {
            deleteAuth({
                authid: row.id
            }).then(() => {
                // 获取权限列表
                this.getPermissionsList();
            });
        },
        // 重置info弹出层
        resertInfoForm() {
            this.addInfoForm = {
                id: 0,
                title: "",
                link: "",
                parent: []
            };
        }
    }
};
</script>

<style lang="scss" scoped>
/* 修改可选择范围 */
/deep/ .el-table .cell {
    user-select: text;
}

/deep/ .el-table th > .cell {
    user-select: none;
}
</style>
